const snackbarStore = {
  state: {
    active: false,
    text: '',
    to: ''
  },
  actions: {
    async callSnackbar (context, payload) {
      if (context.state.active) {
        await sleep(1000)
        context.dispatch('callSnackbar', payload)
      } else {
        payload.active = true
        context.commit('updateSnackbar', payload)
        await sleep(5000)
        payload.active = false
        context.commit('updateSnackbar', payload)
      }
    }
  },
  getters: {
    snackbarActive: state => {
      return state.active
    }
  },
  mutations: {
    updateSnackbar (state, payload) {
      state.active = payload.active
      state.text = payload.text
      if (payload.to) {
        state.to = payload.to
      } else {
        state.to = null
      }

    },
  }
}


function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default snackbarStore
